import { Group, Stack } from '@mantine/core';
import type { Measure, MeasureMetadata } from '../../../../api/work-periods-client/work-periods-client.type';
import { useTranslation } from 'react-i18next';
import { Text } from '../../../../ui-library/typography/typography';
import { MeasureItem } from './measure-item';

type Props = {
  groupName: string;
  measures: MeasureMetadata[];
  isFirst: boolean;
  showTrends: boolean;
  selectedMeasures: Measure[];
  selectedMeasureTrends?: Measure[];
  maxSelectedMeasures?: number;
  onMeasureToggle: (measure: Measure) => void;
  onTrendsToggle?: (measure: Measure) => void;
};

export const MeasureGroup = ({
  groupName,
  measures,
  isFirst,
  showTrends,
  selectedMeasures,
  selectedMeasureTrends = [],
  maxSelectedMeasures,
  onMeasureToggle,
  onTrendsToggle,
}: Props) => {
  const i18n = useTranslation();
  return (
    <Stack>
      <Group justify="space-between">
        <Text size="small" weight="bold">
          {groupName}
        </Text>
        {isFirst && showTrends && (
          <Text size="small" weight="bold">
            {i18n.t('process_analysis.filters.trends')}
          </Text>
        )}
      </Group>

      {measures.map((measure) => (
        <MeasureItem
          key={measure.measure_name}
          measure={measure}
          isSelected={selectedMeasures.includes(measure.measure_name as Measure)}
          isSelectedTrends={selectedMeasureTrends.includes(measure.measure_name as Measure)}
          showTrends={showTrends}
          selectedMeasuresCount={selectedMeasures.length}
          maxSelectedMeasures={maxSelectedMeasures}
          onMeasureToggle={onMeasureToggle}
          onTrendsToggle={onTrendsToggle}
        />
      ))}
    </Stack>
  );
};
